module.exports = __webpack_public_path__ + "img/vision.35ac3d82.png";